import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {Observable} from 'rxjs';
import {HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  // store the URL so we can redirect after logging in
  redirectUrl: string;

  constructor(private apiService: ApiService) { }

  getPaymentPage(jobId): Observable<any> {
    return this.apiService.get('/v2/api/employer/payment/single/' + jobId);
  }

  getPaymentBankPage(id, amount): Observable<any> {
    return this.apiService.get('/v2/api/employer/payment/bank/' + id + `?a=${amount}`);
  }

  getPlans() {
    return this.apiService.get('/v2/api/employer/products');
  }

  getOrderDetails(id: string) {
    return this.apiService.get('/v2/api/employer/payment/order/' + id);
  }
}
